import { ChannelProvider } from 'ably/react';
import { PropsWithChildren } from 'react';

type ChannelProps = {
  channelName: string,
}

export const AblyWebsocketChannelProvider = (props: PropsWithChildren<ChannelProps>) => {
  let { children, channelName } = props;

  return (
    <ChannelProvider channelName={channelName}>
      {children}
    </ChannelProvider>
  );
}
